module.exports = __webpack_public_path__ + "6ea591e9ab43ab379aaea7d89b191997.svg";